<!--
 * @FileDescription: 登录页面
 * @Author: 陈文景
 * @Date: 未知
 * @LastEditors: 陈文景
 * @LastEditTime: 2022-09-22 14:30:32
-->
<template>
  <div class="f-c-c" style="height: 100vh;">
    <div class="login">
      <div class="left">
        <img src="../../assets/img/login-img.jpg" alt="" />
      </div>

      <div class="right">
        <div v-show="!isEditPassword" class="login-box">
          <span class="title">Kakaclo后台管理系统</span>
          <el-form label-position="top" ref="form" :rules="rules" :model="form">
            <el-form-item class="username-form-item" label="账户" prop="username">
              <el-input size="medium" prefix-icon="el-icon-user" v-model.trim="form.username" placeholder="请输入账户" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input size="medium" type="password" show-password prefix-icon="el-icon-lock" v-model.trim="form.password" placeholder="请输入密码" @keyup.enter.native="submit" />
            </el-form-item>
          </el-form>
          <div class="edit-password">
            <span @click="editPassword">修改密码</span>
          </div>
          <div class="login-footer">
            <el-button class="login-btn" size="medium" type="primary" :loading="loading" @click="login">登 陆</el-button>
          </div>
        </div>

        <EditPassword v-if="isEditPassword" @returnLogin="isEditPassword = false" />
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { encrypt } from '@/utils/encryp'
import EditPassword from './components/EditPassword.vue'

export default {
  components: {
    EditPassword
  },
  data() {
    let checkUsername = (rule, value, callback) => {
      let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/
      if (!value) {
        callback(new Error('请输入账户'))
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
        this.$refs.form.clearValidate('username')
      }
    }

    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
        this.$refs.form.clearValidate('password')
      }
    }

    return {
      loading: false, // 登录按钮的loading

      rules: {
        username: [{ validator: checkUsername, trigger: ['blur', 'change'] }],
        password: [{ validator: checkPassword, trigger: ['blur', 'change'] }]
      },
      form: {
        grant_type: 'password', // 请求模式
        client_id: 'client_admin', // 客户端唯一ID
        client_secret: 'admin_secret', // 客户端密秘钥
        username: '', // 用户名
        password: '' // 密码
      },
      isEditPassword: false, // 是否是修改密码

      redirect: undefined // 重定向的路径
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    // 修改密码
    editPassword() {
      this.isEditPassword = true
      this.$refs.form.resetFields()
    },

    // 密码输入框的回车事件
    submit() {
      this.login()
    },

    // 登陆
    login() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false
        let form = { ...this.form }
        let formData = new FormData()
        formData.append('grant_type', form.grant_type)
        formData.append('client_id', form.client_id)
        formData.append('client_secret', form.client_secret)
        formData.append('username', form.username)
        formData.append('password', encrypt(form.password))

        API.login(formData).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          let data = res.data
          // 只有角色是3||4||10（管理员||超管||客服）才能登陆后台
          // if (!(data.authorities.includes('3') || data.authorities.includes('4') || data.authorities.includes('10'))) {
          //   this.loading = false
          //   throw new Error('账号密码错误')
          // }
          let userInfo = {
            id: data.userId,
            name: data.fullName,
            role: data.authorities.includes('4') ? '4' : data.authorities[0],
            // isGetPermission: 0
          }
          this.$store.dispatch('user/setUserInfo', userInfo)
          this.$store.dispatch('user/setToken', data.accessToken)
          this.$store.dispatch('user/getUserPerissions').then(() => {
            this.$router.replace({ path: this.redirect || '/' }).catch(() => {})
          })
          this.$refs.form.resetFields()
          
        }).catch(result => {
          this.$message.error(result.data.message)
        })
        .finally(() => {
          this.loading = false
        })
        // try {
        //   this.loading = true
        //   let { data, code, message } = await API.login(formData)
        //   if (code !== 10000) {
        //     throw new Error(message)
        //   }
        //   // 只有角色是3||4||10（管理员||超管||客服）才能登陆后台
        //   // if (!(data.authorities.includes('3') || data.authorities.includes('4') || data.authorities.includes('10'))) {
        //   //   this.loading = false
        //   //   throw new Error('账号密码错误')
        //   // }
        //   let userInfo = {
        //     id: data.userId,
        //     name: data.fullName,
        //     role: data.authorities.includes('4') ? '4' : data.authorities[0],
        //     isGetPermission: 0
        //   }
        //   this.$store.dispatch('user/setUserInfo', userInfo)
        //   this.$store.dispatch('user/setToken', data.accessToken)
        //   this.$router.replace({ path: this.redirect || '/' }).catch(() => {})
        //   this.$refs.form.resetFields()
        //   this.loading = false
        // } catch (error) {
        //   this.loading = false
        //   this.$message.error(error)
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  width: 966px;
  height: 547px;
  background-color: #fff;
  overflow: hidden;
  border-radius: 8px;
  .left {
    flex: 1;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-box {
      width: 258px;
      .title {
        display: inline-block;
        color: rgb(153, 196, 28);
        width: 100%;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 22px;
      }
      .el-form-item {
        margin-bottom: 0 !important;
      }
      .username-form-item {
        margin-bottom: 12px !important;
      }
      /deep/.el-form-item__label {
        line-height: 32px;
        padding: 0 !important;
      }
      .edit-password {
        display: inline-block;
        width: 100%;
        color: rgb(153, 196, 28);
        font-size: 13px;
        text-align: right;
        span {
          user-select: none;
          cursor: pointer;
        }
      }
      .login-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        .login-btn {
          width: 100%;
          padding: 8px 38px;
        }
      }
    }
  }
}
</style>
